import React, { useEffect, useState, useRef, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
// import ItemService from "../services/ItemsServices";
// import UomService from "../services/UomService";
import Breadcrumb from "../components/Breadcrumb";
import CompanyService from "../services/companyService";
import ProjectService from "../services/ProjectService";
import ProjectStoreService from "../services/ProjectStoreService";
import StorageService from "../services/StorageService";
import stockTransferService from "../services/stockTransferService";
import transportersService from "../services/TransporterService";
import ProjectItemService from "../services/ProjectItemService";
import Select from "react-select";
import Loading from "../components/loading";
import MessageDialog from "../components/MessageDialog";

export default function AddStockTransfer() {
  const [companyName, setCompanyName] = useState("Default Company");
  const [isEdit, setIsEdit] = useState(false);
  const [stockItems, setStockItems] = useState([
    { itemCategoryId: "", itemId: "", description: "", uom: "", quantity: "", availableQty: 0 },
  ]);


  const [items, setItems] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [saving, setSaving] = useState(false);

  const { id } = useParams();
  const [loading, setLoading] = useState(!!id);


  const [projectFullData, setProjectFullData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchText, setSearchText] = useState({});

  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  // const messageTimer = useRef(null);
  const [transferType, setTransferType] = useState("INTERNAL");

  const navigate = useNavigate();

  const [transporters, setTransporters] = useState([]);

  const loadTransporters = async () => {
    try {
      // dropdown → always load first page
      const res = await transportersService.getActiveTransporters(1, 100);

      setTransporters(res?.data || []);
    } catch {
      setTransporters([]);
    }
  };

  const [companies, setCompanies] = useState([]);
  const [fromProjects, setFromProjects] = useState([]);
  const [fromStores, setFromStores] = useState([]);
  const [toProjects, setToProjects] = useState([]);
  const [toStores, setToStores] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [toProjectId, setToProjectId] = useState("");
  const [toStoreId, setToStoreId] = useState("");


  const [fromCompanyId, setFromCompanyId] = useState("");
  const [toCompanyId, setToCompanyId] = useState("");

  const filteredToCompanies = useMemo(() => {
    return transferType === "COMPANY"
      ? companies.filter(c => String(c.id) !== String(fromCompanyId))
      : [];
  }, [transferType, companies, fromCompanyId]);



  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const fromStoreIdValue = watch("fromStore");

  const selectedStore = fromStores.find((s) => String(s.storeId ?? s.id) === String(fromStoreIdValue));
  const storeName = selectedStore ? selectedStore.storeName || selectedStore.name || "" : "";

  const getFilteredCategories = () => {
    return categories;
  };

  const formatQty3 = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    return Number(val).toFixed(3);
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const loadItemsByProject = async (projectId) => {
    if (!projectId) {
      setItems([]);
      return;
    }

    try {
      const res = await ProjectItemService.getByProjectId(projectId);
      const list = res?.data?.data || [];

      const mapped = list.map((x) => ({
        id: x.itemId,
        itemId: x.itemId,
        itemName: x.itemCode,
        itemDescription: x.itemDescription,
        uomName: x.uomName,
      }));

      setItems(mapped);
    } catch (err) {
      console.error("Project items load error", err);
      setItems([]);
    }
  };

  const handleCategoryChange = (index, categoryId) => {
    const updated = [...stockItems];
    updated[index].itemCategoryId = categoryId;
    updated[index].itemId = "";
    updated[index].uom = "";
    updated[index].availableQty = 0;
    setStockItems(updated);
  };


  const getItemOptions = (categoryId) => {
    const cat = projectFullData.find(
      (c) => String(c.itemCategoryId) === String(categoryId)
    );

    if (!cat) return [];

    return cat.items.map((i) => ({
      value: i.itemId,
      label: i.itemCode,
    }));
  };

  const getTodayDate = () => new Date().toISOString().split("T")[0];

  useEffect(() => {
    if (id || isEdit) return;
    reset({
      fromProject: "",
      fromStore: "",
      toCompany: "",
      toProject: "",
      toStore: "",
      voucherNo: "",
      transferDate: getTodayDate(),

      // 🔥 ADD THESE TWO
      transporterId: "",
      vehicleNo: "",
      stockTransferNote: "",
    });

    setProjectId("");
    setToProjectId("");
    setToStoreId("");
    setFromStores([]);
    setToStores([]);
    setToCompanyId("");

    // (optional but recommended – keeps data clean)
    setItems([]);
    setStockItems([
      { itemId: "", uom: "", quantity: "", availableQty: 0 }
    ]);
  }, [transferType, id, isEdit]);

  const loadToProjects = async (companyId) => {
    try {
      const res = await ProjectService.getActive(companyId);
      const dataList = res?.data || res || [];

      const mapped = (Array.isArray(dataList) ? dataList : []).map(p => ({
        projectId: p.id ?? p.projectId,
        projectName: p.projectName,
        projectCode: p.projectCode
      }));

      setToProjects(mapped);
      return mapped;
    } catch (err) {
      console.error("Error loading to projects:", err);
      setToProjects([]);
      return [];
    }
  };

  useEffect(() => {

    if (!id) return;

    const loadTransfer = async () => {

      setLoading(true);
      try {

        const res = await stockTransferService.getById(id);
        const data = res?.data?.data || res?.data;

        if (!data) return;

        setIsEdit(true);

        const isCompanyTransfer = String(data.fromCompanyId) !== String(data.toCompanyId);
        const type = isCompanyTransfer ? "COMPANY" : "INTERNAL";
        setTransferType(type);

        const targetToCompId = String(data.toCompanyId);
        setToCompanyId(targetToCompId);
        setValue("toCompany", targetToCompId);

        setProjectId(String(data.fromProjectId));
        setToProjectId(String(data.toProjectId));

        setValue("fromProject", data.fromProjectId);
        await loadToProjects(targetToCompId);
        setValue("toProject", data.toProjectId);

        await loadStores(data.fromProjectId, "FROM");
        await loadStores(data.toProjectId, "TO");

        setValue("fromStore", data.fromStoreId);
        setValue("toStore", data.toStoreId);
        setToStoreId(String(data.toStoreId));

        // 🔥 LOAD PROJECT FULL DATA FIRST
        const fullRes = await ProjectItemService.getProjectFullData(data.fromProjectId);
        const fullData = fullRes?.data?.data || [];

        setProjectFullData(fullData);
        setCategories(fullData);

        setValue("voucherNo", data.vocherNo);
        setValue("transferDate", data.transferDate?.split("T")[0]);
        setValue("transporterId", data.transporterId);
        setValue("vehicleNo", data.vehicleNo);
        setValue("stockTransferNote", data.stockTransferNote);

        // 🔥 NOW MAP ITEMS USING fullData
        const mappedItems = await Promise.all(
          data.stockTransferDetails.map(async (d) => {

            let categoryId = "";

            fullData.forEach(cat => {
              const found = cat.items.find(
                i => Number(i.itemId) === Number(d.itemId)
              );
              if (found) categoryId = cat.itemCategoryId;
            });

            let availableQty = 0;

            try {

              const company = StorageService.activeCompany();
              const stockRes = await stockTransferService.getAvailableStock(
                company.companyId,
                data.fromProjectId,
                data.fromStoreId,
                d.itemId
              );

              availableQty = formatQty3(stockRes?.data?.quantity);

            } catch (err) {
              availableQty = 0;
            }

            return {
              itemCategoryId: categoryId,
              itemId: d.itemId,
              description: d.itemDescription,
              uom: d.UOM,
              quantity: d.quantity,
              availableQty
            };

          })
        );
        setStockItems(mappedItems);
        setTimeout(() => {
          setLoading(false);
        }, 300);

      } catch (err) {
        console.error("Edit load error", err);

      }

    };

    loadTransfer();

  }, [id]);

  useEffect(() => {
    if (id || isEdit) return;
    if (
      transferType === "INTERNAL" &&
      fromCompanyId
    ) {
      setToCompanyId(fromCompanyId);
      loadToProjects(fromCompanyId);
    }
  }, [transferType, fromCompanyId, id, isEdit]);


  const handleAddRow = () => {
    setStockItems([
      ...stockItems,
      { itemId: "", uomId: "", description: "", uom: "", quantity: "", availableQty: 0 }
    ]);
  };




  useEffect(() => {
    const comp = StorageService.activeCompany();
    if (comp?.companyId) {
      setFromCompanyId(comp.companyId);
      setValue("fromCompany", comp.companyId);
    }
  }, [setValue]);

  useEffect(() => {
    const loadCompanies = async () => {
      try {
        const res = await CompanyService.getActiveCompanies();
        setCompanies(res?.data || res || []);
      } catch (err) {
        console.error("Company load error", err);
      }
    };

    loadCompanies();
  }, []);





  useEffect(() => {
    loadFromProjects();
  }, []);




  const loadFromProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN & DATA ADMIN → ALL PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }

      setFromProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setFromProjects([]);
    }
  };


  useEffect(() => {
    if (id || isEdit) return;
    if (transferType === "COMPANY") {
      if (toCompanyId) {
        loadToProjects(toCompanyId);
      } else {
        setToProjects([]);
      }
    }
  }, [toCompanyId, transferType, id, isEdit]);

  useEffect(() => {
    loadTransporters();
  }, []);

  // Auto-select dropdowns if only 1 option is available
  useEffect(() => {
    if (fromProjects.length === 1 && !isEdit) {
      const singleProj = fromProjects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      setValue("fromProject", pId);
      setProjectId(pId);
      
      // Inline fromProject onChange logic:
      setValue("fromStore", "");
      setValue("voucherNo", "");
      setFromStores([]);
      setItems([]);
      clearStockDetails();
      loadStores(pId, "FROM");
      loadItemsByProject(pId);
      loadProjectFullData(pId);
    }
  }, [fromProjects, isEdit]);

  useEffect(() => {
    if (toProjects.length === 1 && !isEdit) {
      const singleProj = toProjects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      if (toProjectId !== pId) {
        setToProjectId(pId);
        setValue("toProject", pId);
        
        // Inline toProject onChange logic:
        setToStoreId("");
        setValue("toStore", "");
        setToStores([]);
        loadStores(pId, "TO");
      }
    }
  }, [toProjects, isEdit, toProjectId]);

  useEffect(() => {
    if (fromStores.length === 1 && !isEdit) {
      const singleStore = fromStores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      setValue("fromStore", sId);
      
      // Inline fromStore onChange logic:
      const pId = getValues("fromProject") || projectId;
      clearStockDetails();
      if (pId && sId) {
        fetchVoucherNo(pId, sId);
      } else {
        setValue("voucherNo", "");
      }
    }
  }, [fromStores, isEdit, projectId, getValues]);

  useEffect(() => {
    const isCompanyTransfer = transferType === "COMPANY";
    const fromProj = String(watch("fromProject") || projectId || "");
    const toProj = String(watch("toProject") || toProjectId || "");
    const isSameProject = !isCompanyTransfer && fromProj && toProj && fromProj === toProj;

    const filteredToStores = isSameProject
      ? toStores.filter(s => String(s.storeId ?? s.id) !== String(watch("fromStore")))
      : toStores;

    if (filteredToStores.length === 1 && !isEdit) {
      const singleStore = filteredToStores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      
      // Inline toStore onChange logic:
      const fromStore = String(watch("fromStore") || "");
      if (isSameProject && sId === fromStore) {
        showMessage("From Store and To Store cannot be the same");
        setToStoreId("");
        setValue("toStore", "");
      } else {
        setToStoreId(sId);
        setValue("toStore", sId);
      }
    }
  }, [toStores, isEdit, transferType, projectId, toProjectId]);

  useEffect(() => {
    if (filteredToCompanies.length === 1 && !isEdit) {
      const singleComp = filteredToCompanies[0];
      const cId = String(singleComp.id);
      if (toCompanyId !== cId) {
        setValue("toCompany", cId);
        
        // Inline toCompany onChange logic:
        setToCompanyId(cId);
        setToProjectId("");
        setValue("toProject", "");
        setToStoreId("");
        setValue("toStore", "");
        setToStores([]);
      }
    }
  }, [filteredToCompanies, isEdit, toCompanyId]);

  useEffect(() => {
    if (transporters.length === 1 && !isEdit) {
      const singleTrans = transporters[0];
      const tId = String(singleTrans.id ?? singleTrans.transporterId);
      setValue("transporterId", tId);
    }
  }, [transporters, isEdit]);

  const loadStores = async (projectId, type = "FROM") => {
    const res = await ProjectStoreService.getProjectStoreById(projectId);
    if (type === "FROM") setFromStores(res.data || res || []);
    else setToStores(res.data || res || []);
  };



  const handleDeleteRow = (index) => {
    const updated = [...stockItems];
    updated.splice(index, 1);
    setStockItems(updated);
  };

  const handleChange = (index, field, value) => {
    if (
      field === "itemId" &&
      value &&
      stockItems.some(
        (row, rowIndex) => rowIndex !== index && String(row.itemId) === String(value)
      )
    ) {
      showMessage("This item is already selected in another row.", "error");
      return;
    }

    const updated = [...stockItems];
    updated[index][field] = value;
    setStockItems(updated);
  };

  const handleQuantityChange = (index, e) => {
    let value = e.target.value;

    // allow only numbers + decimal with at most 3 decimal places
    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    setStockItems(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        quantity: value
      };
      return updated;
    });
  };

  const handleQuantityBlur = (index) => {
    setStockItems(prev => {
      const updated = [...prev];
      const val = updated[index].quantity;
      if (val !== "" && !isNaN(Number(val))) {
        updated[index].quantity = Number(val).toFixed(3);
      }
      return updated;
    });
  };

  const loadProjectFullData = async (projectId) => {
    try {
      const res = await ProjectItemService.getProjectFullData(projectId);
      const data = res?.data?.data || [];
      setProjectFullData(data);
      setCategories(data);
    } catch (err) {
      console.error("Category load error", err);
      setProjectFullData([]);
      setCategories([]);
    }
  };


  const onSubmit = async (data) => {

    try {
      const login = StorageService.loginData();


      // 🔹 BASIC VALIDATION
      if (!isEdit) {
        if (!data.fromProject || !data.fromStore || !data.toProject || !data.toStore) {
          showMessage("Please select all required fields");
          return;
        }
        if (transferType === "COMPANY" && !toCompanyId) {
          showMessage("To Company is required");
          return;
        }
      }

      const fromProj = String(data.fromProject || projectId || "");
      const toProj = String(data.toProject || toProjectId || watch("toProject") || "");
      const fromStore = String(data.fromStore || watch("fromStore") || "");
      const toStore = String(data.toStore || watch("toStore") || "");

      if (transferType !== "COMPANY" && fromProj === toProj && fromStore === toStore) {
        showMessage("From Store and To Store cannot be the same");
        return;
      }

      if (!stockItems.length) {
        showMessage("Please add at least one item");
        return;
      }

      const duplicateItemIds = stockItems
        .map((item) => String(item.itemId).trim())
        .filter(Boolean);

      if (duplicateItemIds.length !== new Set(duplicateItemIds).size) {
        showMessage("Duplicate items are not allowed in Stock Transfer details");
        return;
      }

      for (const item of stockItems) {
        if (!item.itemId) {
          showMessage("Please select item");
          return;
        }

        if (!isEdit && item.availableQty <= 0) {
          showMessage("No available stock for selected item");
          return;
        }

        if (
          item.quantity === undefined ||
          item.quantity === null ||
          isNaN(parseFloat(item.quantity)) ||
          parseFloat(item.quantity) <= 0
        ) {
          showMessage("Please enter valid quantity");
          return;
        }

        const qty = parseFloat(item.quantity);
        const avail = parseFloat(item.availableQty || 0);
        if (qty > avail) {
          showMessage("Quantity exceeds available stock");
          return;
        }
      }

      setSaving(true);

      // 🔹 BUILD PAYLOAD (MATCHES BACKEND EXACTLY)
      const payload = {

        vocherNo: watch("voucherNo"),
        fromCompanyId,
        toCompanyId: transferType === "INTERNAL" ? fromCompanyId : toCompanyId,
        fromProjectId: Number(data.fromProject || projectId),
        toProjectId: Number(data.toProject || watch("toProject")),
        fromStoreId: Number(data.fromStore || watch("fromStore")),
        toStoreId: Number(data.toStore || watch("toStore")),
        fromLocationId: null,
        toLocationId: null,
        transferDate: data.transferDate,
        transporterId: data.transporterId ? Number(data.transporterId) : null,
        vehicleNo: data.vehicleNo?.trim(),
        stockTransferNote: data.stockTransferNote || null,
        status: "intransit",
        roleId: Number(StorageService.loginData()?.roleId),
        createdBy: login?.employeeId || 1,

        stockTransferDetails: stockItems.map(item => ({
          itemId: Number(item.itemId),
          UOM: item.uom,
          quantity: Number(item.quantity)
        }))
      };

      // 🔹 API CALL
      let res;

      if (isEdit) {
        res = await stockTransferService.update(id, payload);
      } else {
        res = await stockTransferService.save(payload);
      }

      showMessage("Stock Transfer saved successfully", "success");

      setTimeout(() => {
        navigate("/cpnl/Stocktransfer/view");
      }, 1200);

    } catch (err) {
      console.error(err);
      showMessage(
        err.response?.data?.message || "Stock Transfer failed",
        "error"
      );
    }
    finally {
      setSaving(false); //  STOP SAVING
    }
  };

  const clearStockDetails = () => {
    setStockItems([
      {
        itemCategoryId: "",
        itemId: "",
        description: "",
        uom: "",
        quantity: "",
        availableQty: 0,
      },
    ]);

    setSearchText({});
  };



  const handleCancel = (e) => {
    if (e) {
      if (typeof e.preventDefault === "function") e.preventDefault();
      if (typeof e.stopPropagation === "function") e.stopPropagation();
    }
    try {
      navigate("/cpnl/Stocktransfer/view");
    } catch (err) {
      console.error("Navigation error:", err);
      window.location.href = "/cpnl/Stocktransfer/view";
    }
  };

  const fetchVoucherNo = async (projectId, storeId) => {
    if (!projectId || !storeId) return;

    try {
      const res = await stockTransferService.getVoucherNo(projectId, storeId);
      setValue("voucherNo", res.data.voucherNo);
    } catch (err) {
      console.error("Voucher fetch failed", err);
    }
  };


  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify StockTransfer" : "Add StockTransfer"}
        secondTitle="Inventory"
      ></Breadcrumb>

      <div className="card p-4 bg-white shadow-sm">
        {loading ? (
          <div className="text-center py-5">
            <Loading />
          </div>
        ) : saving ? (
          <div className="text-center py-5">
            <Loading />
          </div>
        ) : (
          <>
            {/* {message && (
              <div
                className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                  } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
                style={{ borderRadius: "5px" }}
              >
                <span>{message}</span>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeMessage}
                  style={{ fontSize: "0.8rem" }}
                />
              </div>
            )} */}

            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />


            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Transfer Type</label>
                  <div className="d-flex gap-4 mt-1 mb-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="transferType"
                        checked={transferType === "INTERNAL"}
                        disabled={isEdit}
                        onChange={() => setTransferType("INTERNAL")}
                      />
                      <label className="form-check-label">Internal Transfer</label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="transferType"
                        checked={transferType === "COMPANY"}
                        disabled={isEdit}
                        onChange={() => setTransferType("COMPANY")}
                      />
                      <label className="form-check-label">To Company Transfer</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  {transferType === "COMPANY" && (
                    <div className="col-md-12 mb-3">
                      <label>To Company <span className="text-danger">*</span></label>
                      <select
                        disabled={isEdit}
                        className={`form-select ${errors.toCompany ? "is-invalid" : ""}`}
                        {...register("toCompany", {
                          required: transferType === "COMPANY" && !isEdit && "To Company is required"
                        })}
                        value={String(toCompanyId || watch("toCompany") || "")}
                        onChange={(e) => {
                          const selectedCompany = String(e.target.value);

                          setToCompanyId(selectedCompany);
                          setValue("toCompany", selectedCompany, { shouldValidate: true });
                          setToProjectId("");
                          setValue("toProject", "");
                          setToStoreId("");
                          setValue("toStore", "");
                          setToStores([]);
                        }}
                      >
                        <option value="">Select Company</option>
                        {filteredToCompanies.map(c => (
                          <option key={c.id} value={String(c.id)}>
                            {c.companyName}
                          </option>
                        ))}
                      </select>
                      {errors.toCompany && (
                        <small className="text-danger">
                          {errors.toCompany.message}
                        </small>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label >From Project <span className="text-danger">*</span></label>
                  <select
                    disabled={isEdit}
                    className={`form-select ${errors.fromProject ? "is-invalid" : ""}`}
                    {...register("fromProject", {
                      required: !isEdit && "From Project is required"
                    })}
                    value={String(projectId || watch("fromProject") || "")}
                    onChange={(e) => {
                      const pid = String(e.target.value);
                      setProjectId(pid);
                      setValue("fromProject", pid, { shouldValidate: true });

                      setValue("fromStore", "");
                      setValue("voucherNo", ""); // Clear voucherNo
                      setFromStores([]);

                      setItems([]);   // clear previous items
                      clearStockDetails();

                      if (pid) {
                        loadStores(pid, "FROM");
                        loadItemsByProject(pid);
                        loadProjectFullData(pid);
                      }

                    }}
                  >
                    <option value="">Select Project</option>

                    {fromProjects.map((p) => (
                      <option key={p.projectId} value={String(p.projectId)}>
                        {p.projectCategoryName ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}` : (p.projectCode ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}` : p.projectName)}
                      </option>
                    ))}

                  </select>
                </div>

                {(transferType === "INTERNAL" || toCompanyId) && (
                  <div className="col-md-4 mb-3">
                    <label>To Project<span className="text-danger">*</span></label>
                    <select
                      disabled={isEdit}
                      className={`form-select ${errors.toProject ? "is-invalid" : ""}`}
                      {...register("toProject", {
                        required: !isEdit && "To Project is required"
                      })}
                      value={String(toProjectId || watch("toProject") || "")}
                      onChange={(e) => {
                        const selectedToProject = String(e.target.value);
                        setToProjectId(selectedToProject);
                        setValue("toProject", selectedToProject, { shouldValidate: true });
                        setToStoreId("");
                        setValue("toStore", "");
                        setToStores([]);
                        if (selectedToProject) {
                          loadStores(selectedToProject, "TO");
                        }
                      }}
                    >
                      <option value="">Select Project</option>

                      {toProjects.map(p => (
                        <option
                          key={p.projectId}
                          value={String(p.projectId)}
                        >
                          {p.projectCategoryName ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}` : (p.projectCode ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}` : p.projectName)}
                        </option>
                      ))}

                    </select>
                    {errors.toProject && (
                      <small className="text-danger">
                        {errors.toProject.message}
                      </small>
                    )}
                  </div>
                )}

                <div className="col-md-4 mb-3">
                  <label>From Store<span className="text-danger">*</span></label>
                  <select
                    disabled={isEdit}
                    className={`form-select ${errors.fromStore ? "is-invalid" : ""}`}
                    {...register("fromStore", {
                      required: !isEdit && "From Store is required"
                    })}
                    value={String(watch("fromStore") || "")}
                    onChange={(e) => {
                      const storeId = String(e.target.value);
                      const projectId = String(watch("fromProject") || "");

                      setValue("fromStore", storeId, { shouldValidate: true });
                      clearStockDetails();

                      if (projectId && storeId) {
                        fetchVoucherNo(projectId, storeId);
                      } else {
                        setValue("voucherNo", "");
                      }
                    }}
                  >
                    <option value="">Select Store</option>
                    {fromStores.map(s => (
                      <option
                        key={s.storeId ?? s.id}
                        value={String(s.storeId ?? s.id)}
                      >
                        {s.storeName}
                      </option>
                    ))}
                  </select>
                  {errors.fromStore && (
                    <small className="text-danger">
                      {errors.fromStore.message}
                    </small>
                  )}
                </div>

                {(transferType === "INTERNAL" || toCompanyId) && (
                  <div className="col-md-4 mb-3">
                    <label>To Store<span className="text-danger">*</span></label>
                    <select
                      disabled={isEdit}
                      className={`form-select ${errors.toStore ? "is-invalid" : ""}`}
                      {...register("toStore", {
                        required: !isEdit && "To Store is required"
                      })}
                      value={String(toStoreId || watch("toStore") || "")}
                      onChange={(e) => {
                        const selectedToStore = String(e.target.value);
                        const fromStore = String(watch("fromStore") || "");
                        const fromProj = String(watch("fromProject") || projectId || "");
                        const toProj = String(watch("toProject") || toProjectId || "");

                        if (transferType !== "COMPANY" && fromProj === toProj && selectedToStore && selectedToStore === fromStore) {
                          showMessage("From Store and To Store cannot be the same");
                          setToStoreId("");
                          setValue("toStore", "");
                          return;
                        }
                        setToStoreId(selectedToStore);
                        setValue("toStore", selectedToStore, { shouldValidate: true });
                      }}>
                      <option value="">Select Store</option>
                      {(transferType !== "COMPANY" && String(watch("fromProject") || projectId || "") === String(watch("toProject") || toProjectId || "")
                        ? toStores.filter(s => String(s.storeId ?? s.id) !== String(watch("fromStore")))
                        : toStores
                      ).map(s => (
                        <option
                          key={s.storeId ?? s.id}
                          value={String(s.storeId ?? s.id)}
                        >
                          {s.storeName}
                        </option>
                      ))}
                    </select>
                    {errors.toStore && (
                      <small className="text-danger">
                        {errors.toStore.message}
                      </small>
                    )}
                  </div>
                )}

                <div className="col-md-4 mb-3">
                  <label>Voucher No</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("voucherNo")}
                    readOnly
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label>Transfer Date <span className="text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control"
                    {...register("transferDate", {
                      required: "Transfer Date is required",
                      validate: (value) => {
                        if (!value) return true;

                        // Compare ONLY date part (no timezone)
                        const selected = value; // yyyy-mm-dd
                        const today = new Date().toLocaleDateString("en-CA"); // yyyy-mm-dd

                        if (selected > today) {
                          return "Transaction Date cannot be a future date";
                        }

                        const emp = StorageService.loginData();
                        const isPrivileged =
                          emp?.roleName === "Super Admin" ||
                          emp?.roleName === "SuperAdmin" ||
                          emp?.roleName === "Data Admin" ||
                          emp?.roleName === "DataAdmin" ||
                          Number(emp?.roleId) === 1 ||
                          Number(emp?.roleId) === 2;

                        if (!isPrivileged && selected < today) {
                          return "Only Super Admin and Data Admin can select a past date";
                        }

                        return true;
                      },
                    })}
                  />
                  {errors.transferDate && (
                    <small className="text-danger">
                      {errors.transferDate.message}
                    </small>
                  )}
                </div>

                <div className="col-md-4 mb-3">
                  <label>Transporter</label>
                  <select
                    className="form-select"
                    {...register("transporterId")}
                  >
                    <option value="">Select Transporter</option>
                    {transporters.map((t) => (
                      <option key={t.id ?? t.transporterId} value={t.id ?? t.transporterId}>
                        {t.transporterName || t.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4 mb-3">
                  <label>
                    Vehicle No <span className="text-danger">*</span>
                  </label>

                  <input
                    maxLength={10}
                    type="text"
                    className={`form-control ${errors.vehicleNo ? "is-invalid" : ""}`}
                    placeholder="Example: TS09AB1234"
                    {...register("vehicleNo", {
                      required: "Vehicle No is required"
                    })}
                    onChange={(e) => {
                      const value = e.target.value
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, "");

                      setValue("vehicleNo", value, {
                        shouldValidate: true,
                        shouldDirty: true
                      });
                    }}
                  />

                  {errors.vehicleNo && (
                    <small className="text-danger">
                      {errors.vehicleNo.message}
                    </small>
                  )}
                </div>


                <div className="col-md-4 mb-3">
                  <label className="form-label">Stock Transfer Note</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Stock Transfer Note"
                    {...register("stockTransferNote")}
                  />
                </div>
              </div>


              {/* Stock Transfer Items */}
              <hr />
              <h5>Stock Transfer Items</h5>
              <div className="table-responsive mt-2" style={{ overflowX: "auto", ...(stockItems.length >= 4 ? { maxHeight: "280px", overflowY: "auto" } : {}) }}>
                <table className="table table-bordered mb-0" style={{ tableLayout: "fixed", minWidth: "1400px" }}>
                  <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                    <tr>
                      <th style={{ minWidth: "290px" }}>Item Category</th>
                      <th style={{ minWidth: "370px" }}>Item</th>
                      <th style={{ minWidth: "280px" }}>Description</th>  {/* NEW */}
                      <th style={{ minWidth: "100px" }}>UOM</th>
                      <th style={{ minWidth: "140px" }}>Available Quantity</th>
                      <th style={{ minWidth: "140px" }}>Transfer Quantity</th>
                      <th style={{ minWidth: "80px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stockItems.map((row, index) => (
                      <tr key={index}>
                        <td>
                          {/* <select
                          className="form-select"
                          value={row.itemCategoryId}
                          disabled={isEdit}
                          onChange={(e) =>
                            handleCategoryChange(index, e.target.value)
                          }
                        >
                          <option value="">Select Category</option>
                          {categories.map((c) => (
                            <option key={c.itemCategoryId} value={c.itemCategoryId}>
                              {c.itemCategoryName}
                            </option>
                          ))}
                        </select> */}

                          <Select
                            value={
                              categories
                                .map((c) => ({
                                  value: c.itemCategoryId,
                                  label: c.itemCategoryName,
                                }))
                                .find((opt) => String(opt.value) === String(row.itemCategoryId)) || null
                            }
                            onChange={(selected) =>
                              handleCategoryChange(index, selected ? selected.value : "")
                            }
                            options={getFilteredCategories().map((c) => ({
                              value: c.itemCategoryId,
                              label: c.itemCategoryName,
                            }))}
                            placeholder="Search Category..."
                            isClearable
                            isDisabled={isEdit}
                            menuPlacement="auto"
                            maxMenuHeight={150}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                          />

                        </td>
                        <td>
                          {/* <Select
                          value={
                            getItemOptions(row.itemCategoryId).find(
                              (o) => String(o.value) === String(row.itemId)
                            ) || null
                          }
                          onChange={async (selected) => {
                            const itemId = selected ? selected.value : "";
                            const updated = [...stockItems];
                            updated[index].itemId = itemId;

                            const category = projectFullData.find(
                              c => String(c.itemCategoryId) === String(row.itemCategoryId)
                            );

                            const itemObj = category?.items?.find(
                              i => String(i.itemId) === String(itemId)
                            );
                            updated[index].description = itemObj?.itemDescription || "";
                            const fromProject = watch("fromProject");
                            const fromStore = watch("fromStore");

                            if (!fromCompanyId || !fromProject || !fromStore || !itemId) {
                              updated[index].availableQty = 0;
                              updated[index].uom = "";
                              setStockItems(updated);
                              return;
                            }

                            try {
                              const res = await stockTransferService.getAvailableStock(
                                fromCompanyId,
                                fromProject,
                                fromStore,
                                itemId
                              );

                              updated[index].availableQty = res?.data?.quantity || 0;
                              updated[index].uom = res?.data?.uom || "";
                            } catch (err) {
                              updated[index].availableQty = 0;
                              updated[index].uom = "";
                            }

                            setStockItems(updated);
                          }}
                          options={getItemOptions(row.itemCategoryId)}
                          placeholder="Type at least 2 letters..."
                          isDisabled={isEdit || !row.itemCategoryId}
                          isClearable
                          components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                          onInputChange={(input) => {
                            setSearchText((prev) => ({ ...prev, [index]: input }));
                          }}
                          menuIsOpen={(searchText[index] || "").length >= 2}
                        /> */}

                          <Select
                            value={
                              getItemOptions(row.itemCategoryId).find(
                                (o) => String(o.value) === String(row.itemId)
                              ) || null
                            }
                            onChange={async (selected) => {
                              const itemId = selected ? selected.value : "";
                              const updated = [...stockItems];
                              updated[index].itemId = itemId;

                              const category = projectFullData.find(
                                c => String(c.itemCategoryId) === String(row.itemCategoryId)
                              );

                              const itemObj = category?.items?.find(
                                i => String(i.itemId) === String(itemId)
                              );

                              const itemFromList = items.find(
                                i => String(i.itemId) === String(itemId)
                              );

                              const fallbackUom = itemObj?.uomName || itemObj?.uom || itemFromList?.uomName || "";

                              updated[index].description = itemObj?.itemDescription || itemFromList?.itemDescription || "";
                              updated[index].uom = fallbackUom;

                              const fromProject = watch("fromProject");
                              const fromStore = watch("fromStore");

                              if (!fromCompanyId || !fromProject || !fromStore || !itemId) {
                                updated[index].availableQty = 0;
                                updated[index].uom = fallbackUom;
                                setStockItems(updated);
                                return;
                              }

                              try {
                                const res = await stockTransferService.getAvailableStock(
                                  fromCompanyId,
                                  fromProject,
                                  fromStore,
                                  itemId
                                );

                                updated[index].availableQty = formatQty3(res?.data?.quantity);
                                updated[index].uom = res?.data?.uom || fallbackUom;
                              } catch (err) {
                                updated[index].availableQty = 0;
                                updated[index].uom = fallbackUom;
                              }

                              setStockItems(updated);
                            }}
                            options={getItemOptions(row.itemCategoryId)}
                            placeholder="Search Item..."
                            isDisabled={isEdit || !row.itemCategoryId}
                            isClearable

                            // UI improvements
                            menuPlacement="auto"
                            maxMenuHeight={150}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}

                            // optional: remove arrow
                            components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                          />

                        </td>
                        <td>
                          <input
                            className="form-control fw-bold text-dark"
                            value={row.description}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control fw-bold text-dark"
                            value={row.uom}
                            readOnly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control fw-bold text-dark text-end"
                            value={row.availableQty}
                            readOnly
                          />
                        </td>

                        <td>
                          {/* <input
                          type="number"
                          className="form-control fw-bold text-dark"
                          value={row.quantity}
                          readOnly={isEdit}
                          onChange={(e) => {
                            const qty = Number(e.target.value || 0);

                            if (row.availableQty === 0) {
                              showMessage("No stock available for this item");
                              return;
                            }

                            if (qty > row.availableQty) {
                              showMessage("Quantity exceeds available stock");
                              return;
                            }

                            handleChange(index, "quantity", qty);
                          }}
                          placeholder="Quantity"
                        /> */}

                          <input
                            type="text"
                            className="form-control fw-bold text-dark text-end"
                            value={row.quantity ?? ""}
                            readOnly={isEdit}
                            onChange={(e) => handleQuantityChange(index, e)}
                            onBlur={() => handleQuantityBlur(index)}
                            placeholder="Quantity"
                          />

                        </td>

                        <td className="text-center">
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-2"
                            onClick={handleAddRow}
                            disabled={isEdit}
                          >
                            +
                          </button>
                          {stockItems.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDeleteRow(index)}
                              disabled={isEdit}
                            >
                              -
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-3">
                <button type="submit" className="btn btn-primary me-2" disabled={saving}>
                  <i className="ti ti-circle-check me-1"></i>
                  {saving ? "Saving..." : isEdit ? "Update" : "Save"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={(e) => handleCancel(e)}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form >
          </>
        )}
      </div>
    </>
  );
}